export default "__VITE_ASSET__CIki1jlR__"